function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15,22a1,1,0,0,1-1-1c0-2.32,1.09-3.42,2.47-4.81l.69-.7c2.12-2.22,2.78-3.39,1.33-4.84a3.76,3.76,0,0,0-4.18-.94c-.85.35-1.31.93-1.31,1.29a1,1,0,0,1-2,0,3.69,3.69,0,0,1,2.54-3.14A5.78,5.78,0,0,1,19.9,9.24c3.07,3.06.23,6-1.3,7.63-.24.26-.48.5-.71.73C16.63,18.87,16,19.51,16,21A1,1,0,0,1,15,22Zm.71,2.71A1,1,0,0,0,16,24a1,1,0,1,0-2,0,1,1,0,0,0,1.71.71ZM30,16A14,14,0,1,0,16,30,14,14,0,0,0,30,16Zm-2,0A12,12,0,1,1,16,4,12,12,0,0,1,28,16Z",
  "data-name": "36-FAQ"
});

var SvgSupport = function SvgSupport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSupport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/support.178a618e.svg";
export { ForwardRef as ReactComponent };